module.exports = __webpack_public_path__ + "static/media/cajaPulsidFront.16cdd30d.jpg";